import type { ReactNode } from 'react';

import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';
import type { IProductSpecificationReference } from 'src/types/reference/IProductSpecificationReference';

export enum CustomerPageStep {
  Start = 'Start',
  Quantities = 'Quantities',
  ProductSpecifications = 'ProductSpecifications',
  AdditionalInformation = 'AdditionalInformation',
  ShippingAndContacts = 'ShippingAndContacts',
  Done = 'Done',
}

export type ICustomerStepInfo = {
  step: CustomerPageStep;
  description: string;
  icon: ReactNode;
};

export type ICustomersContext = {
  isEditing: boolean;

  isMobileGuideOpened: boolean;

  isLastCustomerStep: boolean;

  customerStep: CustomerPageStep;
  customerStepsInfo: ICustomerStepInfo[];
  customerStepGuideKey: string | null;

  customerLeadProduct: ICustomerLeadProduct | null;
  customerLeadProductSpecification: IProductSpecificationReference | null;

  onEditing: (newIsEditing: boolean) => void;

  toggleMobileGuideOpened: () => void;

  goNextStep: () => void;
  goBack: () => void;

  setLastCustomerStep: (newIsLastCustomerStep: boolean) => void;

  setCustomerStep: (newCustomerStep: CustomerPageStep) => void;
  setCustomerStepGuideKey: (newCustomerStepGuide: string | null) => void;

  updateCustomerLeadProduct: (updatedCustomerLeadProduct: ICustomerLeadProduct) => void;
};
